import { createSlice } from "@reduxjs/toolkit";
import { initialDataExplorerState } from "../config/config.dataExplorer";

export const dataExplorerSlice = createSlice({
  name: "dataExplorer",
  initialState: initialDataExplorerState,
  reducers: {
    setSelectedRow: (state, action) => {
      state.selectedRow = action.payload;
    },
    setFilter: (state, action) => {
      const { id, value, selectedEntity } = action.payload;
      state.filters[selectedEntity] = {
        ...state.filters[selectedEntity] || {},
        [id]: value,
      };
    },
    removeFilter: (state, action) => {
      const { id, selectedEntity } = action.payload;
      delete state.filters[selectedEntity][id];
    },
    clearFilters: (state) => {
      state.filters = initialDataExplorerState.filters;
    },
    setSelectedEntity: (state, action) => {
      state.selectedEntity = action.payload;
    },
  },
});
